import React from 'react';
import {addNavigationListener, LOCATION} from './navigationHistory';

export const NavigationContext = React.createContext({
  location: '',
  consumedPath: [],
  path: []
});

export class Navigation extends React.Component {

  state = {
    location: LOCATION
  };

  componentDidMount() {
    this.stopListening = addNavigationListener(location => this.setState({location}));
  }

  componentWillUnmount() {
    this.stopListening();
  }

  render() {
    return <NavigationContext.Provider value={{
      path: this.state.location.path,
      consumedPath: [],
      unusedPath: removeTrailingSlashes(this.state.location.path).split('/').reverse(),
      // queryParams: this.state.location.queryParams // -- not needed so far
    }}>
      {this.props.children}
    </NavigationContext.Provider>
  }

}

function removeTrailingSlashes(path) {
  if (path.startsWith('/')) {
    path = path.substring(1);
  }
  if (path.endsWith('/')) {
    path = path.substring(0, path.length - 1);
  }
  return path;
}

export function consumePath(ctx, quantity = 1) {
  const unusedPath = [...ctx.unusedPath];
  const consumedPart = [];
  for (let i = 0; i < quantity; ++i) {
    const item = unusedPath.pop();
    if (!item) {
      break;
    }
    consumedPart.push(item);
  }
  return [{
    ...ctx,
    unusedPath,
    consumedPath: [...ctx.consumedPath, ...consumedPart],
  }, consumedPart];
}